if (!customElements.get('discount-announcement')) {
  customElements.define('discount-announcement', class extends HTMLElement {
    connectedCallback() {
      this.message = this.querySelector('[data-discount-announcement-message]');
      this.requestVersion = 0;
      this.refreshCart = () => this.refresh();
      this.restorePage = (event) => {
        if (event.persisted) this.refresh();
      };
      this.visibilityChanged = () => {
        if (document.visibilityState === 'visible') this.refresh();
      };
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        this.unsubscribe = subscribe(PUB_SUB_EVENTS.cartUpdate, this.refreshCart);
      }
      window.addEventListener('pageshow', this.restorePage);
      document.addEventListener('visibilitychange', this.visibilityChanged);
      this.refresh();
    }

    async refresh() {
      const version = ++this.requestVersion;
      try {
        const response = await fetch(this.dataset.cartUrl, {
          credentials: 'same-origin',
          cache: 'no-store',
          headers: { Accept: 'application/json' },
        });
        if (!response.ok) throw new Error('Cart unavailable');
        const cart = await response.json();
        if (this.isConnected && version === this.requestVersion) this.render(cart);
      } catch {
        if (this.isConnected && version === this.requestVersion) this.hidden = true;
      }
    }

    render(cart) {
      const codes = [...new Set((cart.discount_codes || [])
        .filter((discount) => discount.applicable === true && typeof discount.code === 'string')
        .map((discount) => discount.code))];
      if (!codes.length) {
        this.hidden = true;
        return;
      }

      const confirmedCodes = new Set(codes.map((code) => code.toLocaleLowerCase()));
      let savings = 0;
      const addSavings = (application, amount) => {
        if (application?.type !== 'discount_code') return;
        if (!confirmedCodes.has(String(application.title).toLocaleLowerCase())) return;
        const value = Number(amount);
        if (Number.isFinite(value) && value > 0) savings += value;
      };
      for (const application of cart.cart_level_discount_applications || []) {
        addSavings(application, application.total_allocated_amount);
      }
      for (const item of cart.items || []) {
        for (const allocation of item.line_level_discount_allocations || []) {
          addSavings(allocation.discount_application, allocation.amount);
        }
      }

      let template = this.dataset.appliedMessage;
      let amount = '';
      const shippingCodes = (this.dataset.freeShippingCodes || '').split(',')
        .map((code) => code.trim().toLocaleLowerCase()).filter(Boolean);
      if (shippingCodes.some((code) => confirmedCodes.has(code))) {
        template = this.dataset.shippingMessage;
      }
      if (savings > 0 && cart.currency) {
        const locale = cart.currency === 'COP' && this.dataset.locale.startsWith('es')
          ? 'es-CO' : this.dataset.locale;
        amount = new Intl.NumberFormat(locale, {
          style: 'currency',
          currency: cart.currency,
          maximumFractionDigits: cart.currency === 'COP' ? 0 : 2,
        }).format(savings / 100);
        template = this.dataset.savingsMessage;
      }
      const message = template.replace('[codes]', codes.join(', ')).replace('[amount]', amount);
      if (this.message.textContent !== message) this.message.textContent = message;
      this.hidden = false;
    }

    disconnectedCallback() {
      this.requestVersion++;
      this.unsubscribe?.();
      window.removeEventListener('pageshow', this.restorePage);
      document.removeEventListener('visibilitychange', this.visibilityChanged);
    }
  });
}
